/**
 * The business last signed in to on this device. The sign-in pages use it to show
 * that business's own sign-in (name, logo, colours, no business field) instead of
 * Teknika CRM's generic one, which is only the fallback for a first visit or for
 * someone who picks "a different business".
 */
const KEY = 'teknika_business';

export function lastBusiness(): string {
  try {
    return localStorage.getItem(KEY) ?? '';
  } catch {
    return '';
  }
}

export function rememberBusiness(slug: string) {
  if (!slug) return;
  try {
    localStorage.setItem(KEY, slug);
  } catch {
    // Storage blocked: the generic sign-in shows next time, and nothing breaks.
  }
}
